<template>
  <div class="index_box gWidth">
    <div class="index_l">
      <!-- 新闻 -->
      <el-card>
        <div class="Part1_fl">
          <div class="Part1_carousel">
            <el-carousel trigger="click">
              <el-carousel-item
                v-for="(item, index) in news_l.slice(0, 4)"
                :key="index"
                @click="fnJumpDetailsPage(item.news_id)"
              >
                <el-image
                  :fit="'fill'"
                  style="width: 100%; height: 100%"
                  :src="`http://oss.deyity.com/img/${item.cover_path}`"
                ></el-image>
                <h3 style="padding-left: 10px">{{ item.title }}</h3>
              </el-carousel-item>
            </el-carousel>
          </div>
          <el-card class="client_box" shadow="hover">
            <div class="client">
              <span>安卓手机APP扫码下载：</span>
              <img style="width: 150px" src="../assets/qiuguanAPP.png" />
              <span>iPhone手机推荐使用：</span>
              <el-link type="primary">m.deyity.com</el-link>
            </div>
          </el-card>
        </div>
      </el-card>

      <!-- ----------------------- -->
      <div class="Part2_fl" v-if="false">
        <h3>射手榜</h3>
        <ShooterList />
      </div>
      <div class="Part2_fl">
        <h3>新闻热点</h3>
        <!-- <ul class="Part1_new"> -->
        <el-card
          v-for="(item, index) in news_l.slice(5)"
          :key="index"
          style="margin-top: 10px"
        >
          <div class="information cuP" @click="fnJumpDetailsPage(item.news_id)">
            <div class="information_l">
              <el-image :src="`http://oss.deyity.com/img/${item.cover_path}`">
                <template #error>
                  <el-empty :image-size="50" description="空"></el-empty>
                </template>
              </el-image>
            </div>
            <div class="information_r">
              <h3>{{ item.title }}</h3>
              <p class="conter_s" v-html="item.content"></p>
              <p class="pp">
                <span>{{ item.public_time }}({{ item.reprinted }})</span>
                <span class="pp_span">
                  <span><i class="el-icon-s-promotion"></i>转发</span>
                  <span><i class="el-icon-star-on"></i>收藏</span>
                </span>
              </p>
            </div>
          </div>
        </el-card>
      </div>
      <div class="Part2_fl">
        <h3>比赛分析</h3>
        <Attitudecpn />
      </div>
    </div>
    <div class="index_r">
      <!-- 出清表伤停 -->
      <leagueMatchTeam />
      <!-- 积分 -->
      <League />
    </div>
  </div>
</template>
<script>
import { ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import League from "../components/home_s/Indexcpn/Leaguecpn.vue";
import Attitudecpn from "../components/home_s/Indexcpn/Attitudecpn.vue";
import ShooterList from "../components/home_s/Indexcpn/ShooterList.vue";
import leagueMatchTeam from "../components/home_s/Indexcpn/leagueMatchTeam.vue";
export default {
  components: {
    League,
    Attitudecpn,
    ShooterList,
    leagueMatchTeam,
  },
  setup() {
    let { proxy: _this } = getCurrentInstance();
    let router = useRouter();
    // 初始全部新闻
    let loading = ref(true);
    let noMore = ref(false);
    let pages = ref(1);
    let news_l = ref([]);
    let soccer_news = async () => {
      let obj = { page: pages.value };
      let { data: res } = await _this.$http.get("/news/soccer", {
        params: obj,
      });
      if (res.data.length === 0) {
        loading.value = false;
        noMore.value = true;
        _this.$notify({
          title: "提示",
          message: "已加载全部内容",
          type: "error",
        });
      }
      news_l.value = news_l.value.concat(
        ...JSON.parse(JSON.stringify(res.data))
      );
    };
    // 无限滚动
    const load = () => {
      soccer_news();
      pages.value++;
    };
    load();
    // 跳转详情页
    let fnJumpDetailsPage = (new_id) => {
      let routeUrl = router.resolve({
        path: `/new/detail/${new_id}`,
      });
      window.open(routeUrl.href, "_blank");
    };

    return {
      news_l,
      fnJumpDetailsPage,
      load,
      loading,
      noMore,
    };
  },
};
</script>
<style scoped lang="less">
.index_box {
  display: flex;
  justify-content: space-between;
}
.index_l {
  width: 900px;
}
.Part1_fl {
  display: flex;
  justify-content: space-between;
  .Part1_carousel {
    width: 490px;
    height: 300;
    /* banner */
    .el-carousel {
      width: 490px;
      height: 300;
      border-radius: 6px;
      .el-carousel__item h3 {
        position: absolute;
        bottom: 0;
        color: #fff;
        font-size: 14px;
        width: 100%;
        height: 50px;
        line-height: 30px;
        background: rgba(0, 0, 0, 0.5);
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
  }
  .Part1_new {
    width: 340px;
    list-style: disc;
    .el-link {
      width: 100%;
      overflow: hidden;
      display: -webkit-box; /**对象作为伸缩盒子模型展示**/
      -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
      -webkit-line-clamp: 1; /**显示的行数**/
    }
  }
}
.Part2_fl {
  width: 100%;
  flex-direction: column;
  display: flex;
  h3 {
    font-size: 16px;
    font-weight: normal;
    padding: 10px;
    color: rgb(232, 75, 91);
    font-weight: 600;
  }
}

.information {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover h3 {
    color: #409eff;
  }
  &:hover .conter_s {
    color: #606266;
  }
  .information_l {
    width: 15%;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    .el-image {
      width: 100%;
      height: 100%;
    }
    .el-empty {
      width: 100%;
      height: 100px;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .information_r {
    width: 83%;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h3 {
      color: #000;
      font-weight: 600;
      width: 100%;
      overflow: hidden;
      display: -webkit-box; /**对象作为伸缩盒子模型展示**/
      -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
      -webkit-line-clamp: 1; /**显示的行数**/
    }
    .conter_s {
      height: 20px;
      overflow: hidden;
      display: -webkit-box; /**对象作为伸缩盒子模型展示**/
      -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
      -webkit-line-clamp: 1; /**显示的行数**/
      padding: 10px;
      line-height: 26px;
      background: #eee;
    }
  }
}
.pp {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 600;
  .pp_span {
    span {
      margin: 0 10px;
    }
  }
}

.client_box {
  width: 80%;
  background-color: #444;
  .client {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img {
      margin: 20px 0;
    }
    span {
      color: red;
      font-size: 18px;
    }
  }
}
</style>
